const  navList = [
  //  remove this
  // {
  //     title: 'Hololux™光场复现',
  //     id: 1,
  //     uri: 'http://www.baidu.com',
  //     clickType: 'link'
  // }
]

const whyuse3d = [
  {
    icon: '',
    
  }
]

export {
    navList
}